import { render } from "./indexComponent.vue?vue&type=template&id=7ddffb40&scoped=true"
import script from "./indexComponent.vue?vue&type=script&lang=js"
export * from "./indexComponent.vue?vue&type=script&lang=js"

import "./indexComponent.vue?vue&type=style&index=0&id=7ddffb40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddffb40"]])

export default __exports__